<template>
	<div class="flex-wrapper">
		<TypographyTitle :level="2" class="flex-grow">
			{{ $t('activation-process.header') }}
		</TypographyTitle>
		<Button @click="onLogout">
			<LogoutOutlined /> {{ $t('account.logoutButtonLabel') }}
		</Button>
	</div>

	<div class="form-background max-width-750">
		<TypographyParagraph class="no-mg">
			{{ $t('activation-process.' + status) }}
		</TypographyParagraph>
		<div v-if="status === 'success' || status === 'withoutRover'" class="flex-wrapper pd-top-lg">
			<div class="flex-grow"></div>
			<Button type="primary" @click="gotoHome()">
				{{ $t('activation-process.homeButtonLabel') }}
			</Button>
		</div>
	</div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { TypographyTitle, TypographyParagraph, Button } from 'ant-design-vue';
import { LogoutOutlined } from '@ant-design/icons-vue';

import Api from '@/api/Api';

import { useRoute, useRouter } from 'vue-router';

import { useUserStore } from '@/stores/user';

import { showErrorMessage } from '@/components/common/errorMessage';

import { useLogout } from '@/components/account/useLogout';

export default {
	components: {
		TypographyTitle, TypographyParagraph, Button,
		LogoutOutlined,
	},
	setup() {
		const route = useRoute();
		const router = useRouter();
		const uid = route.params.uid;
		const token = route.params.token;
		const status = ref('activating');
		const userStore = useUserStore();
		onMounted(() => Api.activateAccount(
			uid,
			token,
			response => {
				if (response.status === 'ok') {
					status.value = response.rover_created ? 'success' : 'withoutRover';
					userStore.updateRole(response.role);
				} else {
					status.value = 'error';
					showErrorMessage(response.message);
				}
			},
			error => {
				status.value = 'error';
				showErrorMessage(error.response.data);
			},
		));
		const { onLogout } = useLogout();
		const gotoHome = () => router.push({ name: 'home' });
		return {
			status,
			onLogout,
			gotoHome,
		};
	}
}
</script>
